import { ComponentProps, forwardRef } from "react";

import { PlanName } from "@/apollo/types";
import { formatPlanName } from "@/features/billing";

import { Badge } from "../Badge";

export const PlanFeatureBadge = forwardRef<
  HTMLDivElement,
  { planName: PlanName } & ComponentProps<typeof Badge>
>(({ planName, ...props }, ref) => {
  return (
    <Badge ref={ref} variant="outline" {...props}>
      {formatPlanName(planName)}
    </Badge>
  );
});
